const BUSCANDO = (state, payload) => {
  state.buscando = payload
}

const INSERIR_LISTA_USUARIOS = (state, payload) => {
  state.items = payload
}

const INSERIR_LISTA_PROVEDORES = (state, payload) => {
  state.provedores = payload
}

const INSERIR_USUARIO = (state, payload) => {
  state.items.push(payload)
}

const INSERIR_USUARIO_SELECIONADO = (state, payload) => {
  state.selecionado = payload
}

const ATUALIZAR_USUARIO = (state, payload) => {
  state.items = state.items.map(usuario => {
    if (usuario.id === payload.id) {
      return payload;
    }
    return usuario
  })
}

const DELETAR_USUARIO = (state, payload) => {
  state.items = state.items.filter(usuario => usuario.id !== payload.id)
}

const INSERIR_USUARIO_PERFIL = (state, payload) => {
  state.usuario = payload
}

// const INSERIR_TAREFA_USUARIO_PERFIL = (state,  payload) => {
//   state.tarefas = payload
// }

// const INSERIR_REGIONAL_USUARIO_PERFIL = (state,  payload) => {
//   state.regionais = payload
// }

// const ATUALIZAR_CONTATOS_USUARIO = (state,  payload) => {
//   state.contatos = payload
// }

// const INSERIR_EQUIPES_USUARIO = (state,  payload) => {
//   state.equipes = payload
// }

// const INSERIR_CONFIGURACAO_USUARIO = (state,  payload) => {
//   state.configuracao = payload
// }

// const ATUALIZAR_CONFIGURACAO_ALARME = (state, payload) => {
//   state.items = state.items.map(configuracao => {
//     if(configuracao.id === payload.id) {
//       return payload;
//     }
//     return configuracao
//   })
// }

export {
  BUSCANDO,
  INSERIR_LISTA_USUARIOS,
  INSERIR_USUARIO,
  INSERIR_USUARIO_SELECIONADO,
  ATUALIZAR_USUARIO,
  DELETAR_USUARIO,
  INSERIR_USUARIO_PERFIL,
  INSERIR_LISTA_PROVEDORES,
  // INSERIR_TAREFA_USUARIO_PERFIL,
  // INSERIR_REGIONAL_USUARIO_PERFIL,
  // ATUALIZAR_CONTATOS_USUARIO,
  // INSERIR_EQUIPES_USUARIO,
  // INSERIR_CONFIGURACAO_USUARIO,
  // ATUALIZAR_CONFIGURACAO_ALARME
}
